import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import './Price.scss';
import MonthlyPlanTable from './MonthlyPlanTable';
import ServerPlanTable from './ServerPlanTable';
import CustomPlanTable from './CustomPlanTable';

export default function Price() {
  useEffect(() => {
    const nodes = document.querySelectorAll('.price-page .reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="price-page">
      <Header />

      <section className="page-header">
        <div className="container reveal">
          <div className="breadcrumb">
            <Link to="/">Home</Link> <span>· Pricing</span>
          </div>
          <div className="page-header-grid">
            <div>
              <h1 className="page-title">
                합리적이고,
                <br />
                <span className="em">투명한</span> 요금제.
              </h1>
              <p className="page-sub">
                성도용 앱과 PC 관리자를 기본으로, 교회 규모(인원)에 맞춰
                필요한 앱만 더하는 구조입니다. 500명 이상 규모의 교회는 단독 서버 구축도
                안내해 드립니다.
              </p>
            </div>
            <div className="page-meta">
              <strong>2</strong>
              Plans · 월 요금 / 단독 서버
            </div>
          </div>
        </div>
      </section>

      <section className="pricing" id="pricing">
        <div className="container">
          <h2 className="price-section-title reveal">월 요금 안내</h2>
          <MonthlyPlanTable />

          <h2 className="price-section-title reveal">단독 서버 구축 안내</h2>
          <ServerPlanTable />
          <div className="price-note reveal">
            <p>
              500명 이상 규모의 교회에는 최상의 속도와 보안을 위해 단독 서버
              구축이 적용됩니다.
            </p>
          </div>

          <h2 className="price-section-title reveal">커스텀 제작 안내</h2>
          <CustomPlanTable />

          <div className="pricing-cta reveal">
            <Link to="/inquiry" className="plan-btn">
              문의하기
            </Link>
          </div>
        </div>
      </section>

      <ScrollToTopButton />
      <Footer />
    </div>
  );
}
